import { useEffect, useState, Dispatch, SetStateAction } from "react";
import {
  Nav,
  LogoContainer,
  NavLinks,
  MenuItem as NavLink,
  LogoNavLink,
} from "./navbar.styles";
import { Squash as Hamburger } from "hamburger-react";
import { trackEvent } from "../../helpers";

type ValidRouteProps = {
  isValidRoute: boolean;
  isResumePage: boolean;
  isMobile: boolean;
  setIsMenuIconClicked: Dispatch<SetStateAction<boolean>>;
  isMenuIconClicked: boolean;
  variant?: 'light' | 'dark';
};

export const NavBar = ({
  isValidRoute,
  isMobile,
  isResumePage,
  isMenuIconClicked,
  setIsMenuIconClicked,
  variant = 'light',
}: ValidRouteProps) => {
  const [isScrolled, setIsScrolled] = useState(false);

  const displayMobileNavIcon = () => {
    return (
      isMobile && (
        <Hamburger
          toggled={isMenuIconClicked}
          toggle={setIsMenuIconClicked}
          color={variant === 'dark' ? '#F3ECE1' : '#1A1814'}
        />
      )
    );
  };

  // events tracking
  const handleLogoClick = () => {
    setIsMenuIconClicked(false);
    trackEvent("Logo click");
  };

  // check if page has been scrolled
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isMobile && isMenuIconClicked) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobile, isMenuIconClicked]);

  return (
    <Nav
      isValidRoute={isValidRoute}
      isResumePage={isResumePage}
      variant={variant}
    >
      <LogoContainer>
        <LogoNavLink
          to="/"
          isScrolled={isScrolled}
          isValidRoute={isValidRoute}
          variant={variant}
          onClick={() => handleLogoClick()}
        >
          Renée Louise
        </LogoNavLink>
      </LogoContainer>

      {isMobile ? (
        displayMobileNavIcon()
      ) : (
        <NavLinks isValidRoute={isValidRoute} variant={variant}>
          <NavLink
            to="/services"
            isScrolled={isScrolled}
            isValidRoute={isValidRoute}
            variant={variant}
            onClick={() => trackEvent("Services page click")}
          >
            Services
          </NavLink>
          <NavLink
            to="/the-guide"
            isScrolled={isScrolled}
            isValidRoute={isValidRoute}
            variant={variant}
            className="guide"
            onClick={() => trackEvent("The Guide page click")}
          >
            The Guide
          </NavLink>
          <NavLink
            to="/ai-drama"
            isScrolled={isScrolled}
            isValidRoute={isValidRoute}
            variant={variant}
            className="guide"
            onClick={() => trackEvent("AI Drama page click")}
          >
            AI Drama
          </NavLink>
          <NavLink
            to="/resources"
            isScrolled={isScrolled}
            isValidRoute={isValidRoute}
            variant={variant}
            onClick={() => trackEvent("Resources page click")}
          >
            Resources
          </NavLink>
          <NavLink
            to="/about"
            isScrolled={isScrolled}
            isValidRoute={isValidRoute}
            variant={variant}
            onClick={() => trackEvent("About page click")}
          >
            About
          </NavLink>
          <NavLink
            to="/contact"
            isScrolled={isScrolled}
            isValidRoute={isValidRoute}
            variant={variant}
            className="cta"
            onClick={() => trackEvent("Contact page click")}
          >
            Book a call
          </NavLink>
        </NavLinks>
      )}
    </Nav>
  );
};
